import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                header: 'toggleSection'
            }
        }
    }

    init() {
        if (this.getData('open')) {
            this.$('section')[0].classList.add('is-open');
        }

        this.headers = this.$('header')
        this.headersKeyDownBind = (e) => {
            if(e.code == 'Space' || e.code == 'Enter') {
                e.curTarget = e.currentTarget
                this.toggleSection(e)
            }
        }
        for(let header of Array.from(this.headers)) {
            header.addEventListener('keydown', this.headersKeyDownBind)
        }
    }

    toggleSection(e) {
        const target = typeof e == 'object' ? e.curTarget : this.$('header'+e)[0];
        const section = this.parent('section', target);
        const main = this.$('main', target);

        if (section.classList.contains('is-open')) {
            section.classList.remove('is-open');
            target.setAttribute('aria-expanded', false)
        } else {
            // let lastOpenSection = this.$('section.is-open')
            // if (lastOpenSection.length) {
            //     lastOpenSection[0].classList.remove('is-open');
            //     this.$('header', lastOpenSection[0])[0].setAttribute('aria-expanded', false)
            // }

            section.classList.add('is-open');
            target.setAttribute('aria-expanded', true)
        }

        requestAnimationFrame(() => {
            this.call('update', 'Scroll');
            // this.call('scrollTo', {target: section, duration: 1}, 'Scroll');
        })
    }

    destroy() {
        for(let header of Array.from(this.headers)) {
            header.removeEventListener('keydown', this.headersKeyDownBind)
        }
    }
}
